import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  Button,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  Link,
} from "@mui/material";

import CancelIcon from "@mui/icons-material/Cancel";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import { config } from "../../../../../core/service/config.service";
// import { Grid, Typography } from "@material-ui/core";
import { InputField, DatePickerField } from "../../FormFields";
import { DropzoneArea } from "material-ui-dropzone";

export default function WorkingExperience(props) {
  const formikProps = useFormikContext();

  const [disableEndDate, setDisableEndDate] = useState(false);

  const {
    formField: { workingExperienceList, publication, awards, cvOrResume },
  } = props;

  const [workingExperienceListField, workingExperienceListMeta] = useField(
    workingExperienceList
  );

  const [cvOrResumeField, cvOrResumeMeta] = useField(cvOrResume);

  const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  };

  const handleRemoveClick = (index) => {
    const list = [...workingExperienceListField.value];
    list.splice(index, 1);
    formikProps.setFieldValue(workingExperienceList.name, list);
  };

  const handleAddClick = () => {
    formikProps.setFieldValue(workingExperienceList.name, [
      ...workingExperienceListField.value,
      {
        position: "",
        companyOrganization: "",
        country: "",
        started: "",
        ended: "",
        stillInRole: false,
      },
    ]);
  };

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Working Experience
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          {workingExperienceListField.value?.map((x, i) => (
            <Box key={i}>
              <Card>
                <CardHeader
                  action={
                    i !== 0 && (
                      <IconButton
                        aria-label="settings"
                        onClick={() => handleRemoveClick(i)}
                        sx={{ color: "#DE5C8E" }}
                      >
                        <CancelIcon />
                      </IconButton>
                    )
                  }
                />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        name={workingExperienceList.subMenu[0].position.name}
                        label={workingExperienceList.subMenu[0].position.label}
                        value={workingExperienceListField.value[i].position}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          formikProps.setFieldValue(
                            `workingExperienceList.${i}.position`,
                            e.target.value
                          );
                        }}
                        error={Boolean(
                          workingExperienceListMeta.error
                            ? workingExperienceListMeta.touched &&
                                workingExperienceListMeta.error[i]?.position
                            : false
                        )}
                        helperText={
                          workingExperienceListMeta.error
                            ? workingExperienceListMeta.touched &&
                              workingExperienceListMeta.error[i]?.position
                            : ""
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        name={
                          workingExperienceList.subMenu[0].companyOrganization
                            .name
                        }
                        label={
                          workingExperienceList.subMenu[0].companyOrganization
                            .label
                        }
                        value={
                          workingExperienceListField.value[i]
                            .companyOrganization
                        }
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          formikProps.setFieldValue(
                            `workingExperienceList.${i}.companyOrganization`,
                            e.target.value
                          );
                        }}
                        error={Boolean(
                          workingExperienceListMeta.error
                            ? workingExperienceListMeta.touched &&
                                workingExperienceListMeta.error[i]
                                  ?.companyOrganization
                            : false
                        )}
                        helperText={
                          workingExperienceListMeta.error
                            ? workingExperienceListMeta.touched &&
                              workingExperienceListMeta.error[i]
                                ?.companyOrganization
                            : ""
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        name={workingExperienceList.subMenu[0].country.name}
                        label={workingExperienceList.subMenu[0].country.label}
                        value={workingExperienceListField.value[i].country}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                          formikProps.setFieldValue(
                            `workingExperienceList.${i}.country`,
                            e.target.value
                          );
                        }}
                        error={Boolean(
                          workingExperienceListMeta.error
                            ? workingExperienceListMeta.touched &&
                                workingExperienceListMeta.error[i]?.country
                            : false
                        )}
                        helperText={
                          workingExperienceListMeta.error
                            ? workingExperienceListMeta.touched &&
                              workingExperienceListMeta.error[i]?.country
                            : ""
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="MM/yyyy"
                            minDate={new Date("1990/12/31")}
                            views={["month", "year"]}
                            name={workingExperienceList.subMenu[0].started.name}
                            label={
                              workingExperienceList.subMenu[0].started.label
                            }
                            value={workingExperienceListField.value[i].started}
                            onChange={(date) => {
                              if (isValidDate(date)) {
                                formikProps.setFieldValue(
                                  `workingExperienceList.${i}.started`,
                                  date.toISOString()
                                );
                              } else {
                                formikProps.setFieldValue(
                                  `workingExperienceList.${i}.started`,
                                  date
                                );
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  workingExperienceListMeta.error
                                    ? workingExperienceListMeta.touched &&
                                        workingExperienceListMeta.error[i]
                                          ?.started
                                    : false
                                )}
                                helperText={
                                  workingExperienceListMeta.error
                                    ? workingExperienceListMeta.touched &&
                                      workingExperienceListMeta.error[i]
                                        ?.started
                                    : ""
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} />

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth required>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            disabled={
                              workingExperienceListField.value[i]?.stillInRole
                            }
                            inputFormat="MM/yyyy"
                            minDate={new Date("1990/12/31")}
                            views={["month", "year"]}
                            name={workingExperienceList.subMenu[0].ended.name}
                            label={workingExperienceList.subMenu[0].ended.label}
                            value={workingExperienceListField.value[i].ended}
                            onChange={(date) => {
                              if (isValidDate(date)) {
                                formikProps.setFieldValue(
                                  `workingExperienceList.${i}.ended`,
                                  date.toISOString()
                                );
                              } else {
                                formikProps.setFieldValue(
                                  `workingExperienceList.${i}.ended`,
                                  date
                                );
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  workingExperienceListMeta.error
                                    ? workingExperienceListMeta.touched &&
                                        workingExperienceListMeta.error[i]
                                          ?.ended
                                    : false
                                )}
                                helperText={
                                  workingExperienceListMeta.error
                                    ? workingExperienceListMeta.touched &&
                                      workingExperienceListMeta.error[i]?.ended
                                    : ""
                                }
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={2} sx={{ marginTop: 1 }}>
                      <FormControlLabel
                        name={workingExperienceList.subMenu[0].stillInRole.name}
                        label={
                          workingExperienceList.subMenu[0].stillInRole.label
                        }
                        control={
                          <Checkbox
                            defaultChecked={
                              workingExperienceListField.value[i].stillInRole
                            }
                            name={
                              workingExperienceList.subMenu[0].stillInRole.name
                            }
                            onChange={(e) => {
                              formikProps.setFieldValue(
                                `workingExperienceList.${i}.stillInRole`,
                                e.target.checked
                              );

                              formikProps.setFieldValue(
                                `workingExperienceList.${i}.ended`,
                                ""
                              );
                            }}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Box sx={{ paddingTop: 3 }}>
                {workingExperienceListField.value?.length - 1 === i && (
                  <Button onClick={handleAddClick} variant="contained">
                    Add experience
                  </Button>
                )}
              </Box>
            </Box>
          ))}
        </Grid>

        {/* <Grid item xs={12} sm={12}>
          <InputField
            name={publication.name}
            label={publication.label}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={awards.name}
            label={awards.label}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
          />
        </Grid> */}

        <Grid item xs={12} sm={12}>
          <FormControl fullWidth>
            <Typography variant="subtitle2" sx={{ textAlign: "left" }}>
              {cvOrResume.label}
            </Typography>
            <TextField
              inputProps={{
                accept: "application/pdf",
              }}
              type="file"
              name={cvOrResume.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `cvOrResume.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                cvOrResumeMeta.error
                  ? cvOrResumeMeta.touched && cvOrResumeMeta.error
                  : false
              )}
              helperText={
                cvOrResumeMeta.error
                  ? cvOrResumeMeta.touched && cvOrResumeMeta.error
                  : ""
              }
            />
            <Typography sx={{ textAlign: "left", paddingTop: 1 }}>
              .pdf only
            </Typography>
            {props?.userData?.cvOrResume && (
              <Typography sx={{ textAlign: "left", paddingTop: 1 }}>
                old file:{" "}
                <Link
                  href={`${config.host_api}download/${props?.userData?.cvOrResume}`}
                >
                  {props?.userData?.cvOrResume?.split("-").pop() || " "}
                </Link>
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}
